<template>
  <router-view />
</template>

<script>
export default {
  name: "App",
  data() {
    return {
      defaultPrimaryColor: "#35A79D",
    };
  },
  mounted() {
    document.title = process.env.VUE_APP_TITLE;
    this.defaultPrimaryColor = this.$vuetify.theme.themes.light.primary;
    this.applyThemeOverride();
  },
  methods: {
    applyThemeOverride() {
      const user = this.$store.getters.getUser;
      const email = user?.email?.toLowerCase();
      const themeByEmail = {
        "solcraft@orkofleet.com": "yellow", //QA / Pilot
        "pso-sc@orkofleet.com": "yellow", //PILOT
        // "superadmin@orko.com": "red",
      };
      const theme = themeByEmail[email];
      if (theme) {
        document.documentElement.setAttribute("data-theme", theme);
      } else {
        document.documentElement.removeAttribute("data-theme");
      }

      const primaryColorByTheme = {
        yellow: "#f9af32",
        red: "#d32f2f",
      };
      this.$vuetify.theme.themes.light.primary =
        primaryColorByTheme[theme] || this.defaultPrimaryColor;
    },
  },
};
</script>
